import { render } from "./TiposCreditosList.vue?vue&type=template&id=2f226468&scoped=true"
import script from "./TiposCreditosList.vue?vue&type=script&lang=js"
export * from "./TiposCreditosList.vue?vue&type=script&lang=js"

import "./TiposCreditosList.vue?vue&type=style&index=0&id=2f226468&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f226468"]])

export default __exports__